import React from "react";
import { FaSpinner } from "react-icons/fa6";
import "./loadingButton.css"

// HOC for handling loading states with spinner
const withLoading = (WrappedComponent) => {
  return ({ isLoading, ...props }) => (
    <div className={`buttonWrapper ${isLoading ? "loading" : ""}`}>
      {isLoading && <FaSpinner className="spinnerIcon" />}
      {/* Pass the disabled prop if isLoading is true */}
      <WrappedComponent {...props} disabled={isLoading} />
    </div>
  );
};

const LoadingButton = withLoading((props) => (
  <button {...props}>{props.children}</button>
));

export default LoadingButton;
